import { IMedicationItem } from "../../../interfaces/patient/IMedication"
import { isNil } from "lodash"

export const MedicineTypeOptions = [
	{
		value: "TAB",
		label: "TAB",
	},
	{
		value: "CAP",
		label: "CAP",
	},
	{
		value: "ML",
		label: "ML",
	},
	{
		value: "GM",
		label: "GM",
	},
	{
		value: "TBSP",
		label: "TBSP",
	},
	{
		value: "TSP",
		label: "TSP",
	},
	{
		value: "MG",
		label: "MG",
	},
	{
		value: "UNITS",
		label: "UNITS",
	},
	{
		value: "SPRAY",
		label: "SPRAY",
	},
	{
		value: "PUFFS",
		label: "PUFFS",
	},
	{
		value: "DROPS",
		label: "DROPS",
	},
]

export const MedicineConsumptionTimings = [
	{
		label: "1-0-1",
		value: "1-0-1",
	},
	{
		label: "1-1-1",
		value: "1-1-1",
	},
	{
		label: "0-1-0",
		value: "0-1-0",
	},
	{
		label: "1-1-0",
		value: "1-1-0",
	},
	{
		label: "0-0-1",
		value: "0-0-1",
	},
	{
		label: "1-0-0",
		value: "1-0-0",
	},
	{
		label: "0-1-1",
		value: "0-1-1",
	},
]

export const MedicineFrequencyOptions = [
	{
		label: "Hour",
		value: "HOUR",
	},
	{
		label: "Day",
		value: "DAY",
	},
	{
		label: "Week",
		value: "WEEK",
	},
	{
		label: "Month",
		value: "MONTH",
	},
	{
		label: "Year",
		value: "YEAR",
	},
]

export enum MedicineSlot {
	BREAKFAST = "BREAKFAST",
	LUNCH = "LUNCH",
	DINNER = "DINNER",
}

export const medicineIntakeOptions = [
	{
		value: "BEFORE_FOOD",
		label: "Before food",
	},
	{
		value: "AFTER_FOOD",
		label: "After food",
	},
	{
		value: "BEFORE_SLEEP",
		label: "Before sleep",
	},
	{
		value: "EMPTY_STOMACH",
		label: "Empty stomach",
	},
	{
		value: "ANYTIME",
		label: "Anytime",
	},
]

export const MedicationFrequencyOptions = [
	{
		value: "Once",
		label: "Once",
	},
	{
		value: "Daily",
		label: "Daily",
	},
	{
		value: "Alternate Day",
		label: "Alternate Day",
	},
	{
		value: "Once in 3 days",
		label: "Once in 3 days",
	},
	{
		value: "Twice a week",
		label: "Twice a week",
	},
	{
		value: "Every week",
		label: "Every week",
	},
	{
		value: "Every 15 days",
		label: "Every 15 days",
	},
	{
		value: "Every 30 days",
		label: "Every 30 days",
	},
	{
		value: "Every 3 months",
		label: "Every 3 months",
	},
]

export const PrescriptionMedicationDurationOptions = [
	{
		value: "SOS",
		label: "SOS",
	},
	{
		value: "DAY",
		label: "Day",
	},
	{
		value: "WEEK",
		label: "Week",
	},
	{
		value: "MONTH",
		label: "Month",
	},
	{
		value: "Till next consultation",
		label: "Till next consultation",
	},
]

export const isPrescriptionMedicineValid = (medicine: IMedicationItem) => {
	return (
		medicine?.medicineQuantity?.unit &&
		medicine?.medicineQuantity?.count > 0 &&
		medicine?.medicineDosage &&
		medicine?.medicineInstructions &&
		medicine?.frequency &&
		medicine?.medicineDuration?.unit &&
		(medicine?.medicineDuration?.unit === PrescriptionMedicationDurationOptions[0]?.value ||
			medicine?.medicineDuration?.unit == PrescriptionMedicationDurationOptions[4]?.value ||
			medicine?.medicineDuration?.count > 0)
	)
}

export const validateMedicineDosage = (value: any) => {
	//allow only positive decimals and integers
	if (!value) return true
	const regex = /^[+]?([0-9]+(?:[\.][0-9]*)?|\.[0-9]+)$/
	return regex.test(value)
}
